import React, { PureComponent } from 'react'
import { FormControl, InputLabel, MenuItem, Select, Input, Chip } from '@material-ui/core'

import { isValidString } from '../../utils/string'

import ForwardRefHOC from '../../containers/HOC/ForwardRefHOC'
import ModalDialog from '../common/ModalDialog'
import _ from 'lodash'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

class AddActivityTypeModal extends PureComponent {
  state = {
    name: '',
    description: '',
    categories: [],
  }

  addActivityType = () => {
    const { name, description, categories } = this.state

    if (!isValidString(name)) {
      this.props.onError('Please provide a valid activity type name')
      return
    }
    if (categories.length === 0) {
      this.props.onError('Please provide a activity type categories')
      return
    }

    this.props.addActivityType({ name, description, active: true, categories })
  }

  onClose = () => {
    this.setState({
      name: '',
      description: '',
      categories: [],
    })
  }

  onOpen = (type) => {
    this.setState({
      name: '',
      description: '',
      categories: [],
    })
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  onChangeCategories = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  render() {
    const { forwardedRef } = this.props

    const { name, description, categories } = this.state

    return (
      <ModalDialog
        title={'Add Activity Type'}
        ref={forwardedRef}
        onConfirm={this.addActivityType}
        onClose={this.onClose}
        onOpen={this.onOpen}
      >
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Name *</InputLabel>
          <Input
            name="name"
            value={name}
            onChange={this.onChange}
            fullWidth
            inputProps={{
              maxLength: 50,
            }}
          />
        </FormControl>
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Description *</InputLabel>
          <Input
            name="description"
            value={description}
            onChange={this.onChange}
            fullWidth
            inputProps={{
              maxLength: 50,
            }}
          />
        </FormControl>
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Categories *</InputLabel>
          <Select
            value={categories}
            name="categories"
            onChange={this.onChangeCategories}
            multiple
            input={<Input id="select-multiple-chip" />}
            renderValue={(selected) => (
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {selected.map((value) => {
                  const item = _.find(this.props.categoryList, (i) => i.id === value)
                  return (
                    <Chip key={value} label={item ? item.name : ''} className={{ margin: 2 }} />
                  )
                })}
              </div>
            )}
            MenuProps={MenuProps}
          >
            {this.props.categoryList &&
              this.props.categoryList.map((i) => <MenuItem value={i.id}>{i.name}</MenuItem>)}
          </Select>
        </FormControl>
      </ModalDialog>
    )
  }
}

export default ForwardRefHOC(AddActivityTypeModal)



// WEBPACK FOOTER //
// ./src/components/Modal/AddActivityTypeModal.js